import { Switch } from '@mui/material'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '../../../../components/ui/select'

type SettingsFieldProps = {
    template: any
    value: any
    isEditing: boolean
    onChange: (value: any) => void
}

const SettingsField = ({ template, value, isEditing, onChange }: SettingsFieldProps) => {
    const options = template.options || {}
    const inputClass =
        'h-9 w-full rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-1 focus:ring-ring'

    if (!isEditing) {
        if (value == null) {
            return <span className="text-sm text-muted-foreground">Not set</span>
        }

        if (template.dataType === 'boolean') {
            const trueLabel = options.trueLabel || 'Yes'
            const falseLabel = options.falseLabel || 'No'
            return <span className="text-sm text-foreground">{value ? trueLabel : falseLabel}</span>
        }

        if (template.dataType === 'enum') {
            const choices = options.choices || []
            const choice = choices.find((c: any) => c.value === value)
            return <span className="text-sm text-foreground">{choice?.label || value}</span>
        }

        return <span className="text-sm text-foreground">{String(value)}</span>
    }

    switch (template.dataType) {
        case 'boolean':
            return (
                <Switch
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                    size="small"
                />
            )

        case 'number':
            return (
                <input
                    type="number"
                    value={value ?? ''}
                    onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
                    min={options.min}
                    max={options.max}
                    step={options.step}
                    className={inputClass}
                />
            )

        case 'enum': {
            const choices = options.choices || []
            return (
                <Select value={value ?? ''} onValueChange={onChange}>
                    <SelectTrigger className="h-9">
                        <SelectValue placeholder="Select..." />
                    </SelectTrigger>
                    <SelectContent>
                        {choices.map((c: any) => (
                            <SelectItem key={c.value} value={c.value}>
                                {c.label}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            )
        }

        case 'version':
            return (
                <input
                    value={value ?? ''}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={options.formatHint || 'e.g. 1.0.0'}
                    className={inputClass}
                />
            )

        case 'string':
        default:
            return (
                <input
                    value={value ?? ''}
                    onChange={(e) => onChange(e.target.value)}
                    className={inputClass}
                />
            )
    }
}

export default SettingsField
